import request from '@/utils/request'

// 登录方法
export function login(username, password, code, uuid) {
  return request({
    url: '/auth/login',
    headers: {
      isToken: false
    },
    method: 'post',
    data: { username, password, code, uuid }
  })
}
// 获取验证码
export function getCodeImg() {
  return request({
    url: '/code',
    headers: {
      isToken: false
    },
    method: 'get',
    timeout: 20000
  })
}
// 退出方法
export function logout() {
  return request({
    url: '/auth/logout',
    method: 'delete'
  })
}
//获取服务站
export function getService() {
  return request({
    url: '/system/fwzInfo/getFwzInfo',
    method: 'get',
    timeout: 20000
  })
}
//获取单量
export function express() {
  return request({
    url: '/system/express/delivery',
    method: 'get',
    timeout: 20000
  })
}
//获取车辆数据
export function getCars(){
  return request({
    url: '/system/vehicle/queryDriverAndVehicleList',
    method: 'get',
    timeout: 20000
  })
}
// 根据字典类型查询字典数据信息
export function getDicts(dictType) {
  return request({
    url: '/system/dict/data/type/' + dictType,
    method: 'get'
  })
}
//查看服务站信息
export function shelfInfoGet(data) {
  return request({
    url: '/system/shelfInfo/getSsFwzInfoById',
    method: 'get',
    timeout: 20000,
    params:data
  })
}
//获取实时订单数据
export function getNowOrder(data) {
  return request({
    url: '/system/scm/gylList',
    method: 'post',
    timeout: 20000,
    data:data
  })
}
//获取订单详情
export function getOrderInfo(id) {
  return request({
    url: `/system/scm/info/${id}`,
    method: 'get',
    timeout: 20000,
  })
}
//获取服务站订单
export function getStageOrder(data){
  return request({
    url: '/system/scm/getFwzOrder',
    method: 'post',
    timeout: 20000,
    data:data
  })
}
//获取车辆列表
export function getAllCars(data){
  return request({
    url:'/system/gyl/vehicle',
    method:'post',
    timeout:20000,
    data:data
  })
}
export function getFarmList(data) {
  return request({
    url: '/system/farm/list',
    method: 'post',
    timeout: 20000,
    data:data
  })
}
//查看农场信息
export function getFarmInfo(id) {
  return request({
    url: `/system/farm/getFarm/${id}`,
    method: 'get',
    timeout: 20000,
  })
}
//农场预售情况
export function getFarmPreSale(data) {
  return request({
    url: '/system/farm/preSale',
    method: 'post',
    timeout: 20000,
    data:data
  })
}
//获取车辆位置信息
export function getCarInfo(imeis) {
  return request({
    url: `/system/gyl/local/${imeis}`,
    method: 'get',
    timeout: 20000,
  })
}
//获取农场订单
export function getFarmOrder(id) {
  return request({
    url: `/system/gyl/farm/${id}`,
    method: 'get',
    timeout: 20000,
    meta:true
  })
}
//获得派送详情
export function getOrderDetail(sendId,orderId) {
  return request({
    url: '/delivery/deliverySendInfo/' + sendId + '/' + orderId,
    method: 'get',
    timeout: 20000,
  })
}
//获取订单实时状态
export function getOrderStatus(sendId,orderId) {
  return request({
    url: '/delivery/orderRecord/geRealTimeOrderStatus/' + sendId + '/' + orderId,
    method: 'get',
    timeout: 20000,
  })
}
//获取轨迹信息
export function getGps(data) {
  return request({
    url: '/system/gyl/trail',
    method: 'post',
    timeout: 20000,
    data:data
  })
}
//地址转经纬度
export function getLngLat(location) {
  return request({
    url: `/system/gyl/getLocal/${location}`,
    method: 'get',
    timeout: 20000,
  })
}
//农场订单数据
export function getFarmNum(farmId) {
  return request({
    url: `/system/gyl/orderSales/${farmId}`,
    method: 'get',
    timeout: 20000,
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js